export default {
  categoryList: (state) => state.categoryList.list,
  galleryList: (state) => state.galleryList.list,
  galleryCount: (state) => state.galleryList.count,
  galleryDetail: (state) => state.galleryDetail,
};
